import { errorHandler } from "@/services/toastHandler";

const maintenanceModule = {
  namespaced: true,
  state: {
    loading: false,
    saving: false,
  },
  mutations: {
    LOADING: (s, data) => (s.loading = data),
    SAVING: (s, data) => (s.saving = data),
  },
  actions: {
    async getMaintenanceConfig({ commit }) {
      commit("LOADING", true);
      try {
        const res = await this.$api.get("/v1/portal/settings/detail", {
          params: { key: "maintenance-config" },
        });
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADING", false);
      }
    },
    async updateMaintenanceConfig({ commit }, value) {
      commit("SAVING", true);
      try {
        const res = await this.$api.post("/v1/portal/settings/update", {
          key: "maintenance-config",
          value,
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SAVING", false);
      }
    },
  },
};

export default maintenanceModule;
